import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359415/image-17_h2ycbh.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359415/image-18_svxkvg.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359415/image-19_xus2dg.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">

        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6  md:mb-6 mt-2 text-[#152C24]">COMMUNITY</h1>
     
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745281942/image-6_fi0j3e.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        <div className="flex-1">
        
          <section className="bg-white p-6">
            <h2 className="text-[32px] font-bold text-[#152C24] mb-6">
              <strong className="font-bold text-black">FARMING COMMUNITIES:</strong> How can they benefit?
            </h2>
            <h2 className="font-bold text-[32px] text-black mb-6">
            A farming community—whether it’s a group of smallholder farmers, a cooperative, or an informal farmer network—gets a range of powerful benefits by using the Farmnet App. It helps improve productivity, income, coordination, and access to services as a collective
            </h2>
            <div className="md:space-y-10 text-[32px]  mt-10">
              <div>
                <strong>1. Stronger Market Access</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Sell produce collectively to buyers, ensuring better prices through aggregation.</li>
                  <li>Get real-time market prices to avoid exploitation and improve negotiation power.</li>
                </ul>
              </div>

              <div>
                <strong>2. Collective Bargaining for Inputs & Services</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Purchase farm inputs (seeds, fertilizer, tools) in bulk at lower costs.</li>
                  <li>Access shared services like mechanization, transport, or irrigation as a group.</li>
                </ul>
              </div>

              <div>
                <strong>3. Easier Coordination & Communication</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Stay connected as a community using in-app group chats, alerts, and announcements.</li>
                  <li>Plan planting, harvesting, or community meetings more efficiently.</li>
                </ul>
              </div>

              <div>
                <strong>4. Shared Learning & Knowledge Exchange</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Share farming experiences, pest control methods, and tips through the app.</li>
                  <li>Access training videos, advisory messages, and weather alerts together.</li>
                </ul>
              </div>

              <div>
                <strong>5. Improved Record-Keeping & Transparency</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Digitally manage group records, income, expenses, and harvest data.</li>
                  <li>Enhances trust and accountability within cooperatives or farmer groups.</li>
                </ul>
              </div>

              <div>
                <strong>6. Easier Access to Credit & Finance</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>As a group, it's easier to qualify for loans or grants through aggregated creditworthiness.</li>
                  <li>Use digital records from the app to support financing applications.</li>
                </ul>
              </div>

              <div>
                <strong>7. Resilience Through Collaboration</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Respond better to shocks like drought, pests, or market failures by sharing resources and information.</li>
                  <li>Support each other during tough times through community solidarity.</li>
                </ul>
              </div>

              <div>
                <strong>8. Recognition & Partnerships</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>A digitally connected farming community is more visible to NGOs, buyers, and government programs.</li>
                  <li>More likely to be selected for pilot projects, subsidies, or innovation grants.</li>
                </ul>
              </div>

              <div>
                <strong>9. Youth & Women Empowerment</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Young farmers and women can find leadership opportunities within digital platforms.</li>
                  <li>Farmnet gives them a voice, access, and visibility they might not have in traditional systems.</li>
                </ul>
              </div>

              <div>
                <strong>✅ 10. Long-Term Growth & Sustainability</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>As digital skills grow, the community becomes more self-reliant, productive, and sustainable.</li>
                  <li>Builds a modern farming culture ready for future challenges and opportunities.</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Solutions2;
